import React from 'react';
import PropTypes from 'prop-types';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import { TextInput } from '@els/els-react--text-input';
import { ButtonWithIcon } from '@els/els-react--button';

function PreferredSuppliersHeadingOpened({ checkedCount, onReset = () => {}, onClose = () => {}, searchValue, setSearchValue = () => {} }) {
  const handleResetClick = (e) => {
    e.stopPropagation();
    onReset();
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className="preferred-suppliers-accordion-item__heading rx-accordion-row profile-settings-accordion-row" onClick={onClose}>
      <span className="profile-settings-accordion-row_label">
        {ProfileSettingsConfig.Labels.preferredSuppliers}
        {checkedCount > 0 && <span className="preferred-suppliers-accordion-item__checked-count">{checkedCount}</span>}
      </span>
      <div className="preferred-suppliers-accordion-item__controls">
        <TextInput
          data-e2e="preferred-suppliers-search-input"
          className="preferred-suppliers-accordion-item__search-input"
          label="Search Preferred Suppliers"
          shouldHideLabel
          value={searchValue}
          onClick={handleInputClick}
          onMouseDown={handleInputClick}
          onKeyDown={handleInputClick}
          onChange={(event) => setSearchValue(event?.target?.value ?? event?.currentTarget?.value ?? '')}
        />
        <ButtonWithIcon
          id="preferred-suppliers-reset-button"
          type="link"
          size="small"
          linkIconSize="s"
          data-e2e="preferred-suppliers-reset-button"
          sprite="Undo"
          iconOnly
          onClick={handleResetClick}
          className="preferred-suppliers-accordion-item__reset-button e2e-preferred-suppliers-reset">
          Reset
        </ButtonWithIcon>
        <ButtonWithIcon
          id="preferred-suppliers-close-button"
          type="link"
          size="small"
          data-e2e="preferred-suppliers-close-button"
          linkIconSize="s"
          sprite="Close"
          iconOnly
          onClick={onClose}
          className="preferred-suppliers-accordion-item__close-button e2e-preferred-suppliers-close">
          Close
        </ButtonWithIcon>
      </div>
    </div>
  );
}

PreferredSuppliersHeadingOpened.propTypes = {
  checkedCount: PropTypes.number,
  onReset: PropTypes.func,
  onClose: PropTypes.func,
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.func,
};

export default PreferredSuppliersHeadingOpened;
